export default "__VITE_ASSET__D1SQOLlc__"